import { Injectable } from '@angular/core';
import { AppNavigationItem } from './shell-mfe-utils.service';

@Injectable()
export abstract class MfeUtilsService {
  abstract appName: string;
  abstract isMfe: boolean;
  abstract publishMenu(): void;
  abstract addMenuItemToNav(
    id: string,
    label: string,
    icon: string,
    stateName: string,
    stateParams?: Record<string, unknown>
  ): void;
  abstract addMenuItemWithChildrenToNav(item: AppNavigationItem): void;
  abstract disableMenuItems(): void;
  abstract enableMenuItems(): void;
}
